import { colors } from '../../colors';
var alert = {
  bgColor: colors.rose,
  closeBtnColor: colors.white,
  paraColor: colors.white
};
export default alert;